module.exports = __webpack_public_path__ + "media/brands/buick-ea94fd10.png";